/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {assert} from 'Asserts';
import {SelectedSchemaIds} from 'bulk-import/SpreadsheetBulkImportConstants';
import {Registry} from 'constants/RegistryConstants';
import RegistrySelector from 'registry/RegistrySelector';
import * as StorableModalsUtil from 'samples/StorableModalsUtil';
import {StorableSourceFormGroup} from 'samples/storables/StorableSourceSelector';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

import ModalButtonKey from '../../test/lib/cypress/shared/ModalButtonKey';
import * as SpreadsheetBulkImportActions from '../SpreadsheetBulkImportActions';

// Transforms schemaIdAccessorKey (`containerSchemaId`) to selectedSchemaIdAccessorKey
// (`selectedContainerSchemaId`).
// TODO(T10599): Remove selected prefix from props and store settings and delete function.
function _getSelectedSchemaIdAccessorKey(schemaIdAccessorKey: any): string {
  return `selected${schemaIdAccessorKey.charAt(0).toUpperCase()}${schemaIdAccessorKey.substr(1)}`;
}

export interface StorableImportSettingsModalPaneConfiguration {
  schemaSelectorClass: React.ComponentClass;
  schemaIdAccessorKey: keyof SelectedSchemaIds;
  showProjectSelector: boolean;
}

interface Props {
  modalProps: {
    title: string;
    onRequestClose: () => void;
  };
  projectId?: string | null;
  registry: Registry | null;
  schemaSelectorClass: any;
  schemaIdAccessorKey: keyof SelectedSchemaIds;
  selectedSchemaIds: SelectedSchemaIds;
  showProjectSelector: boolean;
}

class StorableImportSettingsModalPane extends React.Component<Props> {
  /**
   * Returns configuration for StorableImportSettingsModalPane for a given import flow.
   * @param {schemaSelectorClass}     A React component class that extends SchemaSelector
   * @param {schemaIdAccessorKey}     The name of the key in selectedSchemaIds
   */

  static configure({
    schemaSelectorClass,
    schemaIdAccessorKey,
    showProjectSelector,
  }: Pick<
    Props,
    'schemaSelectorClass' | 'schemaIdAccessorKey' | 'showProjectSelector'
  >): StorableImportSettingsModalPaneConfiguration {
    assert(
      schemaSelectorClass && schemaIdAccessorKey && showProjectSelector != null,
      'StorableImportSettingsModalPane is incorrectly configured.'
    );
    return {schemaSelectorClass, schemaIdAccessorKey, showProjectSelector};
  }

  _handleChangeRegistry = (e: any): void => {
    const registry = e.target.value;
    SpreadsheetBulkImportActions.setImportSetting({registryImportSettings: {registry}});
  };

  _handleChangeSchema = (schema: any): void => {
    SpreadsheetBulkImportActions.setImportSetting({
      [_getSelectedSchemaIdAccessorKey(this.props.schemaIdAccessorKey)]: schema.id,
    });
  };

  _handleChangeProject = ({sourceId: projectId}: {sourceId: any}): void => {
    SpreadsheetBulkImportActions.setImportSetting({registryImportSettings: {projectId}});
  };

  render(): JSX.Element {
    const registryId = this.props.registry ? this.props.registry.id : null;
    const selectedSchemaIdAccessorKey = _getSelectedSchemaIdAccessorKey(this.props.schemaIdAccessorKey);
    const isSourceComplete =
      StorableModalsUtil.isSourceComplete(this.props.projectId ?? null) || !this.props.showProjectSelector;
    const shouldEnableNext =
      this.props.registry && this.props.selectedSchemaIds[this.props.schemaIdAccessorKey] && isSourceComplete;
    return (
      <Modal
        enableRedesign={false}
        buttons={[
          {
            key: 'next-from-choose-spreadsheet-btn',
            text: 'Next',
            style: ButtonStyle.SECONDARY,
            onClick: SpreadsheetBulkImportActions.goToNextPane,
            disabled: !shouldEnableNext,
            dataTestAttrs: {component: 'StorableImportSettingsModalPane', key: ModalButtonKey.NEXT},
          },
        ]}
        {...this.props.modalProps}
      >
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label>Registry</label>
              <RegistrySelector onChange={this._handleChangeRegistry} registryId={registryId} />
            </div>
          </Col>
          {this.props.registry && (
            <Col xs={6}>
              <div className="form-group">
                <label>Schema</label>
                <this.props.schemaSelectorClass
                  onChange={this._handleChangeSchema}
                  registryId={this.props.registry.id}
                  shouldShowNoSchemaOption={false}
                  {...{
                    [selectedSchemaIdAccessorKey]:
                      this.props.selectedSchemaIds[this.props.schemaIdAccessorKey],
                  }}
                />
              </div>
            </Col>
          )}
        </Row>
        <Row>
          <Col xs={6}>
            {this.props.showProjectSelector && (
              <StorableSourceFormGroup
                onStorableChange={this._handleChangeProject}
                registryId={registryId}
                selectedSourceId={this.props.projectId ?? null}
              />
            )}
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default StorableImportSettingsModalPane;
